module.exports = __webpack_public_path__ + "img/text-short.1db8cfaa.svg";